import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NgModule,
  LOCALE_ID,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule, RouteReuseStrategy } from '@angular/router';
import {
  AuthModule,
  HttpInterceptorProvider,
  NeedAuthGuard
} from '@app/core/auth';
import { SuperHttpClientModule } from '@app/core/http';
import { SpinnerModule } from '@app/shared/spinner';
import { SidemenuModule } from '@app/shared/sidemenu';

import { CoreModule, RouteReusableStrategy } from '@app/core';
import { SharedModule } from '@app/shared';
import { HomeModule } from './pages/home/home.module';
import { ShellModule } from './shell/shell.module';
import { AboutModule } from './pages/about/about.module';
import { LoginModule } from './pages/login/login.module';
import { ValidateModule } from './pages/validate/validate.module';
import { RecoveryModule } from './pages/recovery/recovery.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { superHttpClientModuleConfig } from './paella-super-http-client.config';
import { ViewsModule } from './views/views.module';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DatetimepickerComponent } from './shared/datetimepicker/datetimepicker.component';
import { CheckboxComponent } from './shared/checkbox/checkbox.component';
import { SelectclienteComponent } from './shared/selectcliente/selectcliente.component';
import { SelectfincaComponent } from './shared/selectfinca/selectfinca.component';
import { CellDateComponent } from './shared/cell-date/cell-date.component';
import { BooleanFormatComponent } from './shared/boolean-format/boolean-format';
import { SensorNameComponent } from './shared/sensor-name/sensor-name';

import esp from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { ClientNameComponent } from './shared/client-name/client-name';
import { ModuleNameComponent } from './shared/module-name/module-name';
import { ClienteNameComponent } from './shared/finca-name/finca-name';
import { StationNameComponent } from './shared/station-name/station-name';
import { ModulePowerSupplyComponent } from './shared/module-power-supply/module-power-supply';
import { DOCUMENT } from '@angular/common';
registerLocaleData(esp);

const authModuleConfig = {
  domain: {
    name: 'example',
    values: {
      url: environment.serverUrl
    },
    isDefault: true
  },
  // Muestra el campo Usuario en Login
  showLoginUsername: false,
  // Muestra el campo Email en Login
  showLoginEmail: true,
  // Muestra el campo Usuario en Registro
  showRegisterUsername: true,
  // Muestra el campo Email en Registro
  showRegisterEmail: true,
  // Muestra el Captcha en Registro
  showRegisterCaptcha: false,
  // Muestra el campo Usuario en Recuperar
  showRecoveryUsername: false,
  // Muestra el campo Email en Recuperar
  showRecoveryEmail: true,
  // Muestra el campo los campos de aceptación de términos y política de privacidad
  showTermsCheckbox: true,
  // Url donde redirigirá el enlace de términos
  termsUrl: '',
  // Url donde redirigirá el enlace de política de privacidad
  privacyUrl: '',
  // API KEY captcha
  siteKey: '',
  // Color spinner
  spinnerColor: '#FF7700',
  // Ruta Angular donde se redirigirá tras login con éxito
  successLoginUrl: '/shell/home',
  // Ruta Angular donde se redirigirá tras logout
  successLogoutUrl: '/login',
  // Idioma por defecto
  i18n: 'es',
  // Indica si se realiza un login automático tras el registro
  directLogin: false,
  // Url relativa login
  loginUrl: '/auth/login',
  // Url relativa register
  registerUrl: '/auth/register',
  // Url relativa recovery
  recoveryUrl: '/auth/recovery',
  // Url relativa refresh
  refreshUrl: '/auth/refresh',
  // Url relativa me
  meUrl: '/auth/me'
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot(authModuleConfig),
    SpinnerModule,
    SidemenuModule,
    CoreModule,
    SharedModule,
    ShellModule,
    HomeModule,
    AboutModule,
    LoginModule,
    ValidateModule,
    RecoveryModule,
    AppRoutingModule,
    ViewsModule,
    SuperHttpClientModule.forRoot(superHttpClientModuleConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    })
    // must be imported as the last module as it contains the fallback route
  ],
  declarations: [AppComponent],
  providers: [
    NeedAuthGuard,
    { provide: RouteReuseStrategy, useClass: RouteReusableStrategy },
    // Garantiza un document válido para dependencias que puedan necesitarlo
    {
      provide: DOCUMENT,
      useFactory: () =>
        typeof document !== 'undefined' ? document : ({} as any)
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorProvider,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es-ES' }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule {}
